import type { PlanningEntityIdentifier } from 'generated/index';

const PREFIX = 'APPOINTMENTS_OVERVIEW';

export const APPOINTMENTS_OVERVIEW_SESSION_STORAGE_KEYS = {
  FILTERED_PARTICIPANT: `${PREFIX}_FILTERED_PARTICIPANT`
};

// The longest period one request may span, both ends inclusive, in calendar years: 1 January to
// 31 December fits, leap year or not. The backend refuses anything longer.
export const APPOINTMENTS_OVERVIEW_MAX_PERIOD_YEARS = 1;

// Entity types supported by the appointments overview participant filter.
export const PARTICIPANT_ENTITY_TYPES: PlanningEntityIdentifier['planningEntityType'][] =
  ['EMPLOYEE', 'CLIENT', 'RESOURCE'];

/** A participant handed over from the calendar via session storage. */
export type AppointmentsOverviewParticipant = {
  planningEntity: PlanningEntityIdentifier;
  label: string;
};
